<template>
  <v-container fluid>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'number'">
      <v-col cols="4">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.name.error"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-select
            v-model="item.category"
            :items="['number', 'text', 'select']"
            :label="$t('category')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-select>
      </v-col>
      <v-col cols="2" v-if="item.category === 'number'">
        <v-text-field
            :value="item.min_value"
            @input="item.min_value = $event !== '' ? $event : null"
            :label="$t('min_value')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.min_value.error"
        >
        </v-text-field>
      </v-col>
      <v-col cols="2" v-if="item.category === 'number'">
        <v-text-field
            :value="item.max_value"
            @input="item.max_value = $event !== '' ? $event : null"
            :label="$t('max_value')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.max_value.error"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'text'">
      <v-col cols="4">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.name.error"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-select
            v-model="item.category"
            :items="['number', 'text', 'select']"
            :label="$t('category')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row no-gutters dense class="flex-nowrap mb-n6" v-if="item.category === 'select'">
      <v-col cols="4">
        <v-text-field
            v-model="item.name"
            :label="$t('name')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
            :error="item.property_state.name.error"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-select
            v-model="item.category"
            :items="['number', 'text', 'select']"
            :label="$t('category')"
            dense
            outlined
            class="mx-1"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-select>
      </v-col>
      <v-col cols="4">
        <v-textarea
            v-model="select_list_text"
            :label="$t('select')"
            @input="onChangeSelectListText()"
            dense
            outlined
            class="mx-1"
            rows="3"
            :filled="readonly"
            :readonly="readonly"
        >
        </v-textarea>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import commonFunction from "@/commonFunction/commonFunction"


export default {
  name: 'BaseAttributeTemplateItem',
  props: {
    item: {type: [Object], default: {}},
    readonly: {type: [Boolean], default: false},
    showDeleted: {type: [Boolean], default: true},
  },

  components: {},

  computed: {},

  watch: {
    item: {
      handler(newValue, oldValue) {
        // console.log('watch')
        if (this.item.category === 'select')
          this.select_list_text = this.item.select_list.join("\r\n")
        this.emitValue()
      },
      deep: true
    },
  },

  methods: {
    emitValue() {
      // console.log('emitValue')
      this.$emit('update:item', this.item)
    },
    onChangeSelectListText() {
      // console.log('onChangeSelectListText', this.select_list_text)
      this.item.select_list = this.select_list_text.split(/\r?\n/).filter(row => row.trim() !== '' && !!row.trim())
    },

  },

  async mounted() {
    if (this.item.category === 'select')
      this.select_list_text = this.item.select_list.join("\r\n")
  },

  data() {
    return {
      select_list_text: null,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n>
{
  "en": {
    "name": "Name",
    "select": "Select",
    "category": "Category",
    "default": "Default",
    "min_value": "Min value",
    "max_value": "Max value"
  },
  "de": {
    "name": "Name",
    "select": "Wählen",
    "category": "Kategorie",
    "default": "Standard",
    "min_value": "Mindestwert",
    "max_value": "Maximalwert"
  }
}
</i18n>
